'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCurrentUser = exports.fetchCurrentUser = exports.deserializeUser = undefined;

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

var deserializeUser = exports.deserializeUser = function deserializeUser(user) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializeUser)(user) : (0, _everydayhero.deserializeUser)(user);
};

var fetchCurrentUser = exports.fetchCurrentUser = function fetchCurrentUser() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchCurrentUser)(params) : (0, _everydayhero.fetchCurrentUser)(params);
};

var updateCurrentUser = exports.updateCurrentUser = function updateCurrentUser() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.updateCurrentUser)(params) : (0, _everydayhero.updateCurrentUser)(params);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/me/index.js
// module id = 220
// module chunks = 0